// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"tableStyle--3i_g1"};